import React from 'react';

import { Icon } from '@chakra-ui/react';
import {
  MdBarChart,
  MdHome,
  MdLock,
  MdOutlineAddPhotoAlternate,
  MdOutlineDirectionsCar,
  MdPerson,
} from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/admin/default';
import Profile from 'views/admin/profile';
import DataTables from 'views/admin/dataTables';
import CreateInspection from 'views/admin/marketplace';
import EditInspection from 'views/admin/inspections/EditInspection';

// Auth Imports
import SignInCentered from 'views/auth/signIn';

const routes = [
  {
    name: 'Main Dashboard',
    layout: '/admin',
    path: '/dashboard',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <MainDashboard />,
  },
  {
    name: 'Inspection List',
    layout: '/admin',
    path: '/inspections',
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    component: <DataTables />,
  },
  {
    name: 'Create Inspection',
    layout: '/admin',
    icon: (
      <Icon
        as={MdOutlineAddPhotoAlternate}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    path: '/inspections/create',
    component: <CreateInspection />,
    hideNavbar: true,
  },
  {
    name: 'Inspection Detail',
    layout: '/admin',
    path: '/inspections/:uuid',
    icon: (
      <Icon
        as={MdOutlineDirectionsCar}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: <Profile />,
    invisible: true,
  },
  {
    name: 'Edit Inspection',
    layout: '/admin',
    path: '/inspections/:uuid/edit',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <EditInspection />,
    invisible: true,
    hideNavbar: true,
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInCentered />,
  },
];

export default routes;
